// extracted by mini-css-extract-plugin
export default {"EmptyListView":"EmptyListView_EmptyListView__bmRCV","Icon":"EmptyListView_Icon__S2pJS"};